export enum AdminCollectionPaths {
  ADMIN_USERS = 'adminUsers',
  EDITOR_SESSIONS = 'editorSessions',
}

export enum PublicCollectionPaths {
  EMAIL_LOG = 'emailLog',
  EMAIL_RECORDS = 'emailRecords',
  PUBLIC_USERS = 'publicUsers',
}

export enum SharedCollectionPaths {
  BLOG_INDEX_REFS = 'blogIndexRefs',
  POSTS = 'posts',
  PODCAST_CONTAINERS = 'podcastContainers',
  PODCAST_EPISODES = 'podcastEpisodes',
  SHARED_RESOURCES = 'sharedResources',
}

export enum MigrationCollectionPaths {
  SUBSCRIBERS = 'subscribers',
  BACKUP_POSTS = 'backupPosts',
  BACKUP_SUBSCRIBERS = 'backupSubscribers',
}
